import { render, staticRenderFns } from "./TxZoomControl.vue?vue&type=template&id=76ee70bf&scoped=true&"
import script from "./TxZoomControl.vue?vue&type=script&lang=js&"
export * from "./TxZoomControl.vue?vue&type=script&lang=js&"
import style0 from "./TxZoomControl.vue?vue&type=style&index=0&id=76ee70bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ee70bf",
  null
  
)

export default component.exports